import { mediaQueryLarge, isMobileBreakpoint } from '@theme/utilities';

class AccordionRow extends HTMLElement {
  // Getter pour l'élément details
  get details() {
    return this.querySelector('[data-ref="accordion-details"]');
  }
  // Champ privé pour gérer le nettoyage automatique des event listeners
  #controller = new AbortController();

  connectedCallback() {
    // Extraction du signal pour associer les event listeners à ce contrôleur
    const { signal } = this.#controller;

    this.#setDefaultOpenState();

    // Ferme les autres accordéons lorsqu'un volet s'ouvre
    this.details?.addEventListener('toggle', this.#handleToggle, { signal });

    // Association de l'event listener avec le signal
    mediaQueryLarge.addEventListener('change', this.#handleMediaQueryChange, { signal });
  }

  // Gestion du démontage de l'élément
  disconnectedCallback() {
    // Nettoyage automatique : supprime TOUS les event listeners associés au signal.
    this.#controller.abort();
  }

  // Gère la fermeture des accordéons voisins pour n'en garder qu'un seul actif
  #handleToggle = () => {
    if (this.details?.open) {
      const parentContainer = this.closest('.accordions') || this.parentElement;
      if (parentContainer) {
        const siblings = parentContainer.querySelectorAll('accordion-row');
        siblings.forEach((sibling) => {
          if (sibling !== this && sibling.details) {
            sibling.details.open = false;
          }
        });
      }
    }
  };

  // Gestion de la modification de la media query
  #handleMediaQueryChange = () => {
    this.#setDefaultOpenState();
  };

  // Définit l'état d'ouverture par défaut de l'accordéon selon les attributs
  #setDefaultOpenState() {
    const isMobile = isMobileBreakpoint();

    if (this.details) {
      this.details.open =
        (isMobile && this.hasAttribute('open-by-default-on-mobile')) ||
        (!isMobile && this.hasAttribute('open-by-default-on-desktop'));
    }
  }
}

if (!customElements.get('accordion-row')) {
  customElements.define('accordion-row', AccordionRow);
}